import { useEffect, useState } from 'react';
import { usePrefersReducedMotion } from 'hooks';

function useParallax(multiplier, clamp = true) {
  const [offset, setOffset] = useState(0);
  const prefersReducedMotion = usePrefersReducedMotion();

  useEffect(() => {
    let ticking = false;
    let animationFrame = null;

    const animate = () => {
      const { innerHeight } = window;
      const offsetValue = Math.max(0, window.scrollY) * multiplier;
      const clampedOffsetValue = Math.max(
        -innerHeight,
         //  innerHeight is fixed 
          // this line below is useful to prevent triggering changing the value  when image is not visible clampedOffsetValue> innerHeight
        Math.min(innerHeight, offsetValue)
      );
      console.table({
        "window.scrollY": window.scrollY,
        "innerHeight": innerHeight,
        "clampedOffsetValue": clampedOffsetValue
      });
      setOffset(clamp ? clampedOffsetValue : offsetValue);
      ticking = false;
    };

    const handleScroll = () => {
      if (!ticking) {
        ticking = true;
        // The window.requestAnimationFrame() method tells the browser that you wish to perform an animation before the next repaint.
        animationFrame = requestAnimationFrame(animate);
      }
    };

    if (!prefersReducedMotion) {
      window.addEventListener('scroll', handleScroll);
    }

    return () => {
      window.removeEventListener('scroll', handleScroll);
      // window.cancelAnimationFrame() method cancels 
      // an animation frame request previously scheduled through a call to window.requestAnimationFrame()
      cancelAnimationFrame(animationFrame);
    };
  }, [clamp, multiplier, prefersReducedMotion]);

  return offset;
}

export default useParallax;
